import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { Content, Title, Description, Footer } from "./styles";
import { useApp } from "../../contexts/AppContext";
import { getWhitelabelFromMemory } from "../../lib/sharedSessionMemory";
import { fetchWhitelabelByChannel } from "../../_services/whitelabelConfig.service";

const hasWhitelabelSessionUi = (wl) =>
  !!(wl?.assets?.name || wl?.assets?.session_expired_redirect_url);

const SessionExpired = () => {
  const { whitelabel, setWhitelabel } = useApp();
  const setWhitelabelRef = useRef(setWhitelabel);
  setWhitelabelRef.current = setWhitelabel;

  useEffect(() => {
    localStorage.removeItem("session_ready");
  }, []);

  useEffect(() => {
    let cancelled = false;
    const fromMemory = getWhitelabelFromMemory();
    if (hasWhitelabelSessionUi(fromMemory)) {
      return undefined;
    }

    (async () => {
      try {
        const data = await fetchWhitelabelByChannel();
        if (!cancelled && data) {
          setWhitelabelRef.current(data);
        }
      } catch (err) {
        console.warn("Whitelabel (sessão expirada):", err?.message || err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const redirectUrl = whitelabel?.assets?.session_expired_redirect_url ?? null;
  const whitelabelName = whitelabel?.assets?.name ?? null;

  return (
    <div className="wl-page">
      <Container>
        <Content>
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginBottom: "24px" }}
          >
            <circle
              cx="28"
              cy="28"
              r="26"
              stroke="var(--primary-color)"
              strokeWidth="2.5"
              fill="none"
            />
            <text
              x="28"
              y="36"
              textAnchor="middle"
              fontSize="22"
              fill="var(--primary-color)"
            >
              i
            </text>
          </svg>
          <Title>Sua sessão expirou</Title>
          <Description>
            Para sua segurança, você precisa acessar{" "}
            {whitelabelName ? whitelabelName : ""} novamente.
          </Description>
        </Content>
      </Container>
      <Footer>
        <button
          onClick={() => {
            if (redirectUrl) window.location.href = redirectUrl;
          }}
          disabled={!redirectUrl}
          className="btn-default-wl mt-5 text-xs font-wl-600 p-2"
        >
          ACESSAR {whitelabelName ? whitelabelName.toUpperCase() : ""} NOVAMENTE
        </button>
      </Footer>
    </div>
  );
};

export default SessionExpired;
